// @flow

import bugsnag from "bugsnag-js";

export default bugsnag(process.env.REACT_APP_BUGSNAG);
